import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import ScrollBars from "react-custom-scrollbars"
import debounce from "lodash/debounce"
import PersonCardShape from "../../../../state/shapes/PersonCardShape"
import PersonCard from "../../../widgets/PersonCard"

const ClearSelectionButton = styled.button`
  color: ${props => props.theme.primaryColor};
  border: 0;
  background: none;
  font-weight: normal;
  margin: 10px 0;
  outline: 0 !important;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

const EmployeeSearchResultsContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  min-height: 200px;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 1em;
  margin-bottom: 1em;
`
const PersonCardContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 0.5em;
  margin-bottom: 0.25em;
`

const CustomReportEmployeeSearch = ({ onChange, t, theme, searchResults }) => {
  const clearSearch = () => {
    this.search.value = ""
    onChange(this.search.value)
  }

  const onDragStart = (e, selectedEmployee) => {
    e.dataTransfer.setData("text/plain", selectedEmployee.employeeId.toString())
  }

  const onSearchChange = debounce(() => {
    if (this.search.value.length > 1) {
      onChange(this.search.value)
    }
  }, 500)

  return (
    <Fragment>
      <div className="row">
        <div className="col-8">
          <input
            id="search"
            type="text"
            className="form-control input-sm"
            onChange={onSearchChange}
            placeholder={t("CustomReport.LocationsEmployeeSelection.EmployeeSearchPlaceholder")}
            ref={input => {
              this.search = input
            }}
          />
        </div>
        <div className="col-4">
          <ClearSelectionButton onClick={clearSearch} primaryColor={theme.primaryColor}>
            {t("CustomReport.LocationsEmployeeSelection.EmployeeSearchClear")}
          </ClearSelectionButton>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <EmployeeSearchResultsContainer>
            <ScrollBars autoHeight autoHeightMin={300}>
              {searchResults && searchResults.length > 0 ? (
                searchResults.map(item => {
                  return (
                    <PersonCardContainer
                      draggable
                      onDragStart={e => {
                        onDragStart(e, item)
                      }}
                      key={item.employeeId}
                    >
                      <PersonCard item={item} highlightedItem={false} />
                    </PersonCardContainer>
                  )
                })
              ) : (
                <em>{t("CustomReport.LocationsEmployeeSelection.NoEmployeesFound")}</em>
              )}
            </ScrollBars>
          </EmployeeSearchResultsContainer>
        </div>
      </div>
    </Fragment>
  )
}

CustomReportEmployeeSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  searchResults: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)),
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired
  }).isRequired
}

CustomReportEmployeeSearch.defaultProps = {
  searchResults: null
}

export default translate()(CustomReportEmployeeSearch)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/LocationsEmployeesSelection/CustomReportEmployeeSearch.jsx